import { SeeOnboardingStepMutationFn } from '../../../../models/graphql';
import { GotoStepPayload, OnboardingReducerFunction } from '../Onboarding.actions';
import updateImmutable from 'immutability-helper';

export const gqlCompleteStep = (mutation: SeeOnboardingStepMutationFn, keyToSend: string, userId: string) =>
  mutation({
    variables: { name: keyToSend },
    optimisticResponse: {
      markOnboardingStepSeen: {
        __typename: 'UserOnboardingStep',
        name: keyToSend
      }
    },
    update: (cache, { data }) => {
      const newStepRef = {
        __ref: cache.identify({
          __typename: 'UserOnboardingStep',
          name: data?.markOnboardingStepSeen.name
        })
      };
      cache.modify({
        id: cache.identify({ id: userId, __typename: 'User' }), // TODO identify user id from payload
        fields: {
          onboarding(existingOnboarding = {}) {
            const existingStepsSeen = existingOnboarding.stepsSeen || [];
            const updatedSteps = [...existingStepsSeen, newStepRef];
            const stepsSeen = Array.from(new Map(updatedSteps.map(step => [JSON.stringify(step), step])).values());
            return {
              ...existingOnboarding,
              stepsSeen
            };
          }
        }
      });
    }
  });
export const gotoStepReducer: OnboardingReducerFunction<GotoStepPayload> = (state, payload) => {
  const { action, index, openNewPost, userId } = payload;
  const { progress } = state;
  if (openNewPost) {
    // we use this set timeout with 0 to make sure we complete the current step
    // only once we have completed rerender due to changes in provider
    setTimeout(() => {
      openNewPost();
    }, 0);
  }
  if (!progress[index].completed && !openNewPost) {
    // we use this set timeout with 0 to make sure we complete the current step
    // only once we have completed rerender due to changes in provider
    setTimeout(() => {
      gqlCompleteStep(action, progress[index].key, userId);
    }, 0);
  }
  return updateImmutable(state, {
    activeStepIndex: { $set: index }
  });
};
